import React from 'react';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const InformationPlan = ({ data, isLoading }) => {
  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="detail">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {isLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Penerimaan'
        )}
      </div>
      <div className="row pt-2">
        {isLoading ? (
          dummy?.map((d, i) => (
            <div className="col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <ListHorizontal title="Kode" content={data?.code} />
            {data?.ref_code && <ListHorizontal title="Ref Code" content={data?.ref_code} />}

            <ListHorizontal title="Pengirim" content={data?.sender} />
            <ListHorizontal title="Tanggal Kedatangan" content={formatDate(data?.schedule_at, 'DD/MM/YYYY')} />
          </>
        )}
      </div>
    </section>
  );
};
